// iOS-like drawer curve, shared by the drawer menu panel transition.
export const MENU_PANEL_EASE = [0.32, 0.72, 0, 1] as const;
export const MENU_PANEL_DURATION = 0.2;
